import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Check } from '@r1-frontend/ui-react/components/svg/main';
import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';
import { TInfoBlockData } from '@r1-frontend/ui-react/organisms/ToggleCard/types';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

interface IProps {
    isActive: boolean,
    type: TInfoBlockData,
    onToggleType: (typeId: TInfoBlockData['id']) => void,
    disabledText?: string,
    isDisabled?: boolean,
}

const ToggleCard = ({ type, isActive, onToggleType, disabledText, isDisabled }: IProps): JSX.Element => {
    const { id, title, info, price, icon } = type;

    const isTablet = useMatchMedia(`(max-width: ${wideBreakpoints.tablet})`);

    return (
        <ST.TypeWrapper isActive={isActive} onClick={() => onToggleType(id)}>
            <ST.TypeContent>
                <ST.TypeDescription>
                    {icon
                        ? <ST.TitleBlock>
                            <ST.Icon>{icon}</ST.Icon>
                            <ST.Title>{title}</ST.Title>
                        </ST.TitleBlock>
                        : <ST.PriceBlock>
                            <ST.Title>{title}</ST.Title>
                            {price && <ST.Price>{price}&nbsp;{RubleSymbol}</ST.Price>}
                        </ST.PriceBlock>
                    }
                    <ST.Info>{info}</ST.Info>
                </ST.TypeDescription>
                <Button
                    bType={isActive ? 'primary' : 'secondary'}
                    size={isTablet ? 'small' : 'large'}
                    Icon={!isDisabled && isActive && <Check />}
                    disabled={isDisabled}
                >
                    {isDisabled ? disabledText : isActive ? 'Выбрано' : 'Выбрать'}
                </Button>
            </ST.TypeContent>
        </ST.TypeWrapper>
    );
};

export default ToggleCard;
